window.$settings_werkregels_result = [];
window.$settings_werkregels_didUpdateChange = true;
window.$settings_werkregels_treeChangeStatus = false;
window.$settings_werkregels_treeList = [];
window.$settings_werkregels_page_number = 1;
window.$settings_werkregels_newInsertId = [];
window.$settings_werkregels_Glist = [];
window.$settings_werkregels_base_Glist = [];
window.$settings_werkregels_content = [];
window.$settings_werkregels_algemeenCode = [];
window.$settings_werkregels_algemeenNaam = [];
window.$settings_werkregels_selectedRow = [];
window.$settings_werkregels_gvv = 1;
window.$settings_werkregels_filterMaatregelenIsActive = [];
window.$settings_werkregels_filterPlannigIsActive = [];
window.$settings_werkregels_filterContent = [];
window.$settings_werkregels_filterClickStatus = false;
window.$settings_werkregels_scroll_change = false;
window.$settings_werkregels_columnList = [];
window.$settings_werkregels_selectedIds = null;
window.$settings_werkregels_token = null;
window.$settings_werkregels_refresh = function (){};
window.$settings_werkregels_table_total_row_count = 0;
window.$settings_werkregels_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$settings_werkregels_actions = [];

window.$settings_post_model = {
  client_identification: "a34090fd-701c-4c82-876c-16257fa6eed1",
  code: "a34090fd-701c-4c82-876c-16257fa6eed1",
  data: {
    aliases: [
      {
        field_name: "tekst01w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst02w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst03w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst04w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst05w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst06w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst07w",
        alias: "",
        visible: false,
      },
      {
        field_name: "tekst08w",
        alias: "",
        visible: false,
      },
    ],
  },
};
